<template>
    <date-range-picker
        :label="label"
        :preset-ranges="presetRanges"
        :init-range="initRangeValue"
        @changed="changed"
        :visible-value="visibleValue"
        :table-id="tableId"
    />
</template>

<script>
    import { FilterMixin } from './mixins/FilterMixin';
    import DateRangePicker from "../date-range-picker/DateRangePicker";
    export default {
        name: "DateRangeFilter",
        mixins:[FilterMixin],
        components:{DateRangePicker},
        props:{
            label:{type:String},
            presetRanges:{type:Array},
            visibleValue:{type:Boolean},
            active: {
                type: [Object, String],
                default: null
            }
        },
        computed: {
            initRangeValue() {
                let value = this.active;

                if ([undefined, null, ''].includes(value)) {
                    return null;
                }

                if (typeof value === 'string') {
                    try {
                        value = JSON.parse(value);
                    } catch (e) {
                        return null;
                    }
                }

                if (!value?.start || !value?.end) {
                    return null;
                }

                return {
                    start: this.createInternalDate(value.start),
                    end: this.createInternalDate(value.end)
                };
            }
        },
        methods: {
            createInternalDate(value) {
                const date = new Date(value);

                if (isNaN(date.getTime())) {
                    return null;
                }

                return new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1);
            },
            changed(value) {
                this.returnValue(value)
            },
        },
    }
</script>
